export const CLINIC_CREATE_REQUEST = "CLINIC_CREATE_REQUEST";
export const CLINIC_CREATE_SUCCESS = "CLINIC_CREATE_SUCCESS";
export const CLINIC_CREATE_FAIL = "CLINIC_CREATE_FAIL";
export const CLINIC_CREATE_RESET = "CLINIC_CREATE_RESET";

export const CLINIC_DETAILS_REQUEST = "CLINIC_DETAILS_REQUEST";
export const CLINIC_DETAILS_SUCCESS = "CLINIC_DETAILS_SUCCESS";
export const CLINIC_DETAILS_FAIL = "CLINIC_DETAILS_FAIL";
export const CLINIC_DETAILS_RESET = "CLINIC_DETAILS_RESET";

export const CLINIC_UPDATE_REQUEST = "CLINIC_UPDATE_REQUEST";
export const CLINIC_UPDATE_SUCCESS = "CLINIC_UPDATE_SUCCESS";
export const CLINIC_UPDATE_FAIL = "CLINIC_UPDATE_FAIL";
export const CLINIC_UPDATE_RESET = "CLINIC_UPDATE_RESET";

export const LIST_USER_CLINICS_REQUEST = "LIST_USER_CLINICS_REQUEST";
export const LIST_USER_CLINICS_SUCCESS = "LIST_USER_CLINICS_SUCCESS";
export const LIST_USER_CLINICS_FAIL = "LIST_USER_CLINICS_FAIL";
export const LIST_USER_CLINICS_RESET = "LIST_USER_CLINICS_RESET";
